import autocomplete from '../autocomplete/autocomplete';
import toggleMenu from './toggleMenu';
import toggleSearch from './toggleSearch';
export default function header() {
    const menuButton = document.querySelector('#spv-menuButton');
    const searchButton = document.querySelector('#header-search-button');
    const shortcutsButton = document.querySelector('#header-shortcuts-button');
    const systemsButton = document.querySelector('#header-systems-button');
    autocomplete({ elementID: 'header-autocomplete' });
    function syncHeight() {
        document.documentElement.style.setProperty('--window-inner-height', `${window.innerHeight}px`);
    }
    function closeAllMenus(exclude) {
        if (exclude !== '#header-systems') {
            toggleMenu('#header-systems', '#header-systems-button', '.spv-header', true);
        }
        if (exclude !== '#header-menu') {
            toggleMenu('#header-menu', '#spv-menuButton', '.spv-header', true);
        }
        if (exclude !== '#header-shortcuts') {
            toggleMenu('#header-shortcuts', '#header-shortcuts-button', '.spv-header', true);
        }
    }
    function handleSystemsMenu() {
        syncHeight();
        toggleSearch(true);
        closeAllMenus('#header-systems');
        toggleMenu('#header-systems', '#header-systems-button', '.spv-header');
    }
    function handleShortcutsMenu() {
        syncHeight();
        toggleSearch(true);
        closeAllMenus('#header-shortcuts');
        toggleMenu('#header-shortcuts', '#header-shortcuts-button', '.spv-header');
    }
    function handleGlobalMenu() {
        syncHeight();
        toggleSearch(true);
        closeAllMenus('#header-menu');
        toggleMenu('#header-menu', '#spv-menuButton', '.spv-header');
    }
    function handleSearch() {
        syncHeight();
        closeAllMenus();
        toggleSearch();
    }
    menuButton.addEventListener('click', handleGlobalMenu);
    searchButton.addEventListener('click', handleSearch);
    if (shortcutsButton) {
        shortcutsButton.addEventListener('click', handleShortcutsMenu);
    }
    if (systemsButton) {
        systemsButton.addEventListener('click', handleSystemsMenu);
    }
}
header();
//# sourceMappingURL=header.js.map